import request from '@/utils/request'

export function getShopInfo() {
  return request({
    url: `/api/shop/info`,
    method: 'get'
  })
}

export function getSettingInfo() {
  return request({
    url: `/api/shop/setting`,
    method: 'get'
  })
}

export function policyList(params) {
  return request({
    url: `/api/shop/policy`,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/shop.js